export default [
    {
        path: '/ssddt',
        component: () => import('@/views/homePage/menu/suoshuidan_dating/index.vue'),
    },
    {
        path: '/excel',
        component: () => import('@/views/homePage/menu/excel/index.vue'),
    },
    {
        path: '/suoshuiruanjian',
        component: () => import('@/views/homePage/menu/suoshuiruanjian/index.vue'),
    },
    {
        path: '/ssdgw',
        component: () => import('@/views/homePage/menu/ssdgw'),
    },
    {
        path: '/sdssxb',
        component: () => import('@/views/homePage/menu/sdssxb/index.vue'),
    },
    {
        path: '/sttzzbfzx',
        component: () => import('@/views/homePage/menu/sttzzbfzx'),
    },
]
